import { A } from "@solidjs/router";
import { Component, Match, Show, Switch } from "solid-js";
import { RawHtml } from "./raw-html";
import { Img } from "./universal/image";
import { SearchSettings } from "./search-artworks";
import { SalonSubmissionBaseResultItem } from "../Types";
import { P } from "./p";
import { Div } from "./div";
import { slug } from "../library/common";

type SearchHandlers = {
    togglePeoplesChoiceVote: (id: string) => Promise<void>;
};
type Props = {
    settings?: SearchSettings;
    handlers?: SearchHandlers;
    itemWidth: number;
    item: SalonSubmissionBaseResultItem;    
}
export const ArtworkGridItem : Component<Props> = ({ item, settings, handlers, itemWidth: width }) => {
    const peoplesChoiceVoteClicked = (e: Event) => {
        e.preventDefault();
        if (handlers?.togglePeoplesChoiceVote) {
            handlers.togglePeoplesChoiceVote(item.Id);
        }
    }
    return (
        <div class="grid-item" style={{ "display": "inline-block", "vertical-align": "top", "text-align": "left", width: `${width}px`, "max-width": `${width}px` }}>
            <div style={{ "position": "relative", "background-color": item.Image.DominantColourHexCode || "#333" }}>
                <div>
                    <A href={`/artwork/${slug(item.Title)}/${slug(item.Artist)}/${item.Id}`}>
                        <Img 
                            src={item.Image.URL}
                            naturalWidth={item.Image.Width} naturalHeight={item.Image.Height} maxWidth={width}
                            style={{ width: `${width}px` }}
                        />
                    </A>
                </div>
            </div>
            <div class="didactic">
                <Div when={settings?.ShowPeoplesChoiceButton}>
                    <button
                        class="btn"
                        onClick={peoplesChoiceVoteClicked}
                        classList={{
                            ["btn-danger-inverse"]: item.PeoplesChoiceAwardVote,
                            ["btn-danger"]: !item.PeoplesChoiceAwardVote
                        }}>{item.PeoplesChoiceAwardVote ? "Remove Vote" : "Vote"}</button>
                </Div>
                <Show when={settings?.ShowArtist}>
                    <h4>
                        <A href={`/artist/${slug(item.Artist)}/${item.SalonEntrantId}`}>{item.Artist}</A>
                    </h4>
                </Show>
                <h2>
                    <A href={`/artwork/${slug(item.Title)}/${slug(item.Artist)}/${item.Id}`}>
                        <RawHtml value={item.Title} />
                    </A>
                </h2>
                <P when={item.Year}>{item.Year}</P>
                <P when={item.Medium}>{item.Medium}</P>
                <RawHtml value={item.Measurements} />
                <Show when={item.IsExhibiting}>
                    <P when={item.IsExhibitingAtMEAM}>Exhibiting at the MEAM</P>
                    <P when={item.IsExhibitingAtSalmagundi}>Exhibiting at Salmagundi</P>
                </Show>
                <Switch>
                    <Match when={item.IsForSale}>
                        <p>
                            This work is available for purchase, for inquiries please write to <a class="tape" href="mailto:kara.ross@artrenewal.org">kara.ross@artrenewal.org</a>
                        </p>
                    </Match>
                    <Match when={!item.IsForSale}>
                        <P when={item.PurchaseAwardPaidPrice}>
                            This work is in the Collection of the Art Renewal Center.
                        </P>
                        <P when={item.IsExhibiting && !item.PurchaseAwardPaidPrice}>
                            This work is on loan from a private collection.
                        </P>
                    </Match>
                </Switch>
                <Show when={!!item.Teacher || !!item.School || !!item.StudentAge}>
                    <hr />
                    <P when={!!item.Teacher}><b>Taught by:</b> {item.Teacher}</P>
                    <P when={!!item.School}><b>Studied at:</b> {item.School}</P>
                    <P when={!!item.StudentAge}><b>Created by the student at {item.StudentAge} years old</b></P>
                </Show>
            </div>
        </div>
    )
}